export function formatTrending (trending) {
    if (!trending) return null;

    const num = parseFloat(trending);
    if (isNaN(num) || num === 0) return 'no change from the previous period';
    if (num > 0) return `up ${trending}% from the previous period`;

    return `down ${trending.replace('-', '')}% from the previous period`;
}
